__turbopack_context__.v({
  "container": "Stepper-module__VKCQDG__container",
  "filledProgress": "Stepper-module__VKCQDG__filledProgress",
  "icon": "Stepper-module__VKCQDG__icon",
  "progressContainer": "Stepper-module__VKCQDG__progressContainer",
  "stepContainer": "Stepper-module__VKCQDG__stepContainer",
});
